import { Link } from 'react-router-dom';
import { BUSINESS, SITE_URL } from '../seo/businessConfig';

function Footer() {
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${BUSINESS.address.streetAddress}, ${BUSINESS.address.postalCode} ${BUSINESS.address.cityForSearch}`
  )}`;

  return (
    <footer
      className="bg-primary text-primary-bright mt-20"
      itemScope
      itemType="https://schema.org/LodgingBusiness"
    >
      <meta itemProp="name" content={BUSINESS.legalName} />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <p className="font-bold text-2xl tracking-widest mb-4" itemProp="alternateName">
            CZARNA OWCA
          </p>
          <p className="text-sm md:text-base opacity-90 leading-relaxed" itemProp="description">
            {BUSINESS.shortDescription}
          </p>
        </div>

        <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
          <h2 className="text-sm font-thin uppercase tracking-widest opacity-70 mb-3">Adres (NAP)</h2>
          <p className="font-bold leading-snug mb-2">
            <span itemProp="streetAddress">{BUSINESS.address.streetAddress}</span>
            <br />
            <span itemProp="postalCode">{BUSINESS.address.postalCode}</span>{' '}
            <span itemProp="addressLocality">{BUSINESS.address.addressLocality}</span>
            <br />
            <span itemProp="addressRegion">{BUSINESS.address.addressRegion}</span>,{' '}
            <span itemProp="addressCountry">Polska</span>
          </p>
          <p className="text-sm opacity-80 mb-4">
            koło Strzyżowa · ~5 km od centrum · okolice Rzeszowa
          </p>
          <a
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-primary-olive transition-colors text-sm"
          >
            Otwórz w Google Maps
          </a>
        </div>

        <div>
          <h2 className="text-sm font-thin uppercase tracking-widest opacity-70 mb-3">Kontakt</h2>
          <p className="font-bold mb-2">
            <a href={`tel:${BUSINESS.telephone}`} itemProp="telephone" className="hover:text-primary-olive transition-colors">
              {BUSINESS.telephoneDisplay}
            </a>
          </p>
          <p className="font-bold mb-6">
            <a href={`mailto:${BUSINESS.email}`} itemProp="email" className="hover:text-primary-olive transition-colors">
              {BUSINESS.email}
            </a>
          </p>
          <nav aria-label="Stopka">
            <ul className="flex flex-wrap gap-4 text-sm">
              <li><Link to="/" className="hover:text-primary-olive">Start</Link></li>
              <li><Link to="/cennik" className="hover:text-primary-olive">Cennik</Link></li>
              <li><Link to="/galeria" className="hover:text-primary-olive">Galeria</Link></li>
              <li><Link to="/kontakt" className="hover:text-primary-olive">Kontakt</Link></li>
              <li><Link to="/nasza_historia" className="hover:text-primary-olive">Historia</Link></li>
            </ul>
          </nav>
          <link itemProp="url" href={SITE_URL} />
        </div>
      </div>
      <div className="border-t border-primary-bright/20 px-6 py-4 text-center text-xs opacity-70">
        © {new Date().getFullYear()} {BUSINESS.legalName}. Agroturystyka · noclegi · wesela · Brzeżanka / Strzyżów.
      </div>
    </footer>
  );
}

export default Footer;
